import { useState, useEffect } from 'react'

export const mapTimeToLabel = (timeInMs: number): string => {
  const minutes = Math.floor(timeInMs / 60000)
  const seconds = ((timeInMs % 60000) / 1000).toFixed(0)
  return `${minutes}:${parseInt(seconds) < 10 ? `0${seconds}` : seconds}`
}

const useCountdownTimer = (
  initialTime = 0
): {
  time: number
  isRunning: boolean
  start: () => void
  stop: () => void
} => {
  const [time, setTime] = useState<number>(initialTime)
  const [isRunning, setIsRunning] = useState<boolean>(false)

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null

    if (isRunning && time > 0) {
      interval = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime <= 1000) {
            clearInterval(interval as unknown as NodeJS.Timeout)
            setIsRunning(false)
            return 0
          }
          return prevTime - 1000
        })
      }, 1000)
    } else if (!isRunning || time <= 0) {
      clearInterval(interval as unknown as NodeJS.Timeout)
    }

    return (): void => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [isRunning, time])

  const start = (): void => {
    setTime(initialTime)
    setIsRunning(true)
  }

  const stop = (): void => {
    setIsRunning(false)
  }

  return { time, isRunning, start, stop }
}

export default useCountdownTimer
